import { Label } from '@hyperflake/react-ui-library';
import { CalendarIcon } from '@icon/index';
import { DatePicker } from '@library/datepicker';
import BimServicedList from 'modules/analytics/components/BimServicedList/BimServicedList';
import DailyActivityList from 'modules/analytics/components/DailyActivityList/DailyActivityList';
import useBimActivityListData from 'modules/analytics/hooks/useBimActivityListData';
import useDailyActivityListData from 'modules/analytics/hooks/useDailyActivityListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import moment from 'moment';
import { useState } from 'react';

const DailyActivityPage = () => {
    // Date range state (same pattern as SignInLogsListPage)
    const [startDate, setStartDate] = useState(moment().startOf('day'));
    const [endDate, setEndDate] = useState(moment().endOf('day'));

    const formattedStart = startDate.format('YYYY-MM-DD');
    const formattedEnd = endDate.format('YYYY-MM-DD');

    // Update your hook to accept (from, to) similarly to useSignInLogsListData
    const { data: logs, isLoading } = useDailyActivityListData(formattedStart, formattedEnd);

    return (
        <PageTemplate>
            <PageHeading className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                {/* Title */}
                <div className="">Daily Activity</div>

                {/* Filters */}
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                    {/* From Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">From Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 
                            placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={startDate.toDate()}
                                maxDate={endDate.toDate()}
                                onChange={(date) => {
                                    const newStart = moment(date).startOf('day');
                                    setStartDate(newStart);
                                    if (newStart.isAfter(endDate)) {
                                        setEndDate(newStart.endOf('day'));
                                    }
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>

                    {/* To Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">To Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 
                            placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={endDate.toDate()}
                                minDate={startDate.toDate()}
                                onChange={(date) => {
                                    const newEnd = moment(date).endOf('day');
                                    setEndDate(newEnd);
                                    if (newEnd.isBefore(startDate)) {
                                        setStartDate(newEnd.startOf('day'));
                                    }
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>
                </div>
            </PageHeading>

            <div>
                <DailyActivityList isLoading={isLoading} dailyActivity={logs} />
            </div>
        </PageTemplate>
    );
};

export default DailyActivityPage;
